import { withTrackedReducer } from '@angular-architects/ngrx-toolkit';
import { VesselsStoreState } from '@navstation-portal/vessels/data-model/vessel';
import { signalStoreFeature } from '@ngrx/signals';
import { on } from '@ngrx/signals/events';
import { vesselsEvents } from './vessels-events';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function withVesselsReducer<_>() {
  return signalStoreFeature(
    withTrackedReducer(
      on(
        vesselsEvents.fetchVessels,
        (): Partial<VesselsStoreState> => ({
          isFetchingVessels: true,
          fetchError: undefined,
        })
      ),
      on(
        vesselsEvents.fetchVesselsSuccess,
        ({ payload: vessels }): Partial<VesselsStoreState> => ({
          vessels,
          isFetchingVessels: false,
        })
      ),
      on(
        vesselsEvents.fetchVesselsFailed,
        ({ payload: error }): Partial<VesselsStoreState> => ({
          vessels: [],
          isFetchingVessels: false,
          fetchError: error.message,
        })
      ),
      on(
        vesselsEvents.clearVessels,
        (): Partial<VesselsStoreState> => ({
          vessels: [],
        })
      )
    )
  );
}
